function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.71439 4.42852C7.71439 4.9808 7.26667 5.42852 6.71439 5.42852H6.42868C5.87639 5.42852 5.42868 4.9808 5.42868 4.42852V3.14286H2.4C2.17909 3.14286 2 3.32194 2 3.54286V6.5714H18V3.54286C18 3.32194 17.8209 3.14286 17.6 3.14286H14.5715V4.42852C14.5715 4.9808 14.1238 5.42852 13.5715 5.42852H13.2858C12.7335 5.42852 12.2858 4.9808 12.2858 4.42852V3.14286H7.71439V4.42852Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7.71426H2V17.6C2 17.8209 2.17909 18 2.4 18H17.6C17.8209 18 18 17.8209 18 17.6V7.71426ZM5.42878 10.3999C5.42878 10.179 5.60787 9.99995 5.82878 9.99995H7.3145C7.53541 9.99995 7.7145 10.179 7.7145 10.3999V11.8857C7.7145 12.1066 7.53541 12.2857 7.3145 12.2857H5.82878C5.60787 12.2857 5.42878 12.1066 5.42878 11.8857V10.3999ZM5.42878 13.8285C5.42878 13.6076 5.60787 13.4285 5.82878 13.4285H7.3145C7.53541 13.4285 7.7145 13.6076 7.7145 13.8285V15.3142C7.7145 15.5351 7.53541 15.7142 7.3145 15.7142H5.82878C5.60787 15.7142 5.42878 15.5351 5.42878 15.3142V13.8285ZM9.25735 9.99995C9.03644 9.99995 8.85735 10.179 8.85735 10.3999V11.8857C8.85735 12.1066 9.03644 12.2857 9.25735 12.2857H10.7431C10.964 12.2857 11.1431 12.1066 11.1431 11.8857V10.3999C11.1431 10.179 10.964 9.99995 10.7431 9.99995H9.25735ZM8.85735 13.8285C8.85735 13.6076 9.03644 13.4285 9.25735 13.4285H10.7431C10.964 13.4285 11.1431 13.6076 11.1431 13.8285V15.3142C11.1431 15.5351 10.964 15.7142 10.7431 15.7142H9.25735C9.03644 15.7142 8.85735 15.5351 8.85735 15.3142V13.8285ZM12.6859 9.99995C12.465 9.99995 12.2859 10.179 12.2859 10.3999V11.8857C12.2859 12.1066 12.465 12.2857 12.6859 12.2857H14.1716C14.3926 12.2857 14.5716 12.1066 14.5716 11.8857V10.3999C14.5716 10.179 14.3926 9.99995 14.1716 9.99995H12.6859ZM12.2859 13.8285C12.2859 13.6076 12.465 13.4285 12.6859 13.4285H14.1716C14.3926 13.4285 14.5716 13.6076 14.5716 13.8285V15.3142C14.5716 15.5351 14.3926 15.7142 14.1716 15.7142H12.6859C12.465 15.7142 12.2859 15.5351 12.2859 15.3142V13.8285Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57143 2C6.88702 2 7.14286 2.25584 7.14286 2.57143V4.28571C7.14286 4.60131 6.88702 4.85714 6.57143 4.85714C6.25584 4.85714 6 4.60131 6 4.28571V2.57143C6 2.25584 6.25584 2 6.57143 2Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4286 2C13.7442 2 14 2.25584 14 2.57143V4.28571C14 4.60131 13.7442 4.85714 13.4286 4.85714C13.113 4.85714 12.8571 4.60131 12.8571 4.28571V2.57143C12.8571 2.25584 13.113 2 13.4286 2Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.c29d193a248ca6c94e949d758477c3f9.svg";
export { ForwardRef as ReactComponent };